/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */



// ALIA State - START
function sendAliaState(userData, url = "https://6b9vggkr4k.execute-api.us-west-1.amazonaws.com/prod/contacts/list/48") {
  // Require both fields
  console.log(userData)
  if (!userData || !userData.phone || !userData.properties.state) {
    console.log('no')
    return { sent: false };
  }
  let data = {
    email: userData.email,
    phone: userData.phone,
    custom_fields: {
        "76159": userData.properties.state,
        "75581": "USA"
    }
  }

  // Options
  var tries = 3;          
  var baseDelay = 100; 

  // Busy-wait sleep (blocks UI)
  function sleepMs(ms) {
    var end = Date.now() + ms;
    while (Date.now() < end) {}
  }

  for (var attempt = 1; attempt <= tries; attempt++) {
    try {
      var xhr = new XMLHttpRequest();
      xhr.open('POST', url, false); 
      xhr.setRequestHeader('Content-Type', 'application/json');
      xhr.send(JSON.stringify(data));

      var ok = xhr.status >= 200 && xhr.status < 300;
      if (ok) {
        return { sent: true, status: xhr.status, body: xhr.responseText };
      }

      // Retry only on network-ish or server throttling/errors
      var retryable =
        xhr.status === 0 || xhr.status === 429 || (xhr.status >= 500 && xhr.status <= 599);

      if (!retryable) {
        return { sent: false, status: xhr.status, body: xhr.responseText };
      }
    } catch (err) {
      // Transport error -> retry
      if (attempt === tries) {
        return { sent: false, status: 0, error: String(err) };
      }
    }

    // Backoff before next try
    if (attempt < tries) {
      sleepMs(baseDelay * Math.pow(2, attempt - 1)); // 400, 800, 1600...
    }
  }

  return { sent: false, error: 'All retries failed' };
}


// ALIA State - END
